import { AbstractControl, ValidationErrors } from '@angular/forms';

export function nameValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null; // allow empty value, required validator can handle empty

    // Only letters, spaces, dots, hyphens, apostrophes
    const regex = /^[A-Za-z .'-]+$/;

    return regex.test(value) ? null : { invalidName: true };
}